import { isDate } from 'date-fns';
import { t } from 'i18next';
import { ReactNode } from 'react';

import { relativeTimeDestructure } from '../../lib/date';

export interface RelativeDateProps {
  date?: Date | string;
  title?: string;
}

const RelativeDate = ({ date }: RelativeDateProps): ReactNode => {
  if (!date) {
    return null;
  }

  const dateObj = isDate(date) ? date : new Date(date);
  const timeStructure = relativeTimeDestructure(dateObj.getTime());

  return t('relativeDate', timeStructure as any) as ReactNode;
};

export default RelativeDate;
